import { Dispatch, SetStateAction } from "react";
import { DateRange } from "react-day-picker";
import { useTranslation } from "react-i18next";

import { LabeledForm } from "../../../atoms";
import { BadgePicker } from "../../../atoms/BadgePicker";
import DatePickerPopover from "../../../atoms/base/DatePickerPopover";
import { HostedPagesFilterPopover } from "../../components/HostedPagesFilterPopover";

const options = [
  { label: "Expense", value: "expense" },
  { label: "Top Up", value: "topUp" },
];

type WalletHistoryFilterProps = {
  onChange: Dispatch<
    SetStateAction<{
      type: string[] | [];
      range?: DateRange | undefined;
    }>
  >;
  filter: { type: string[] | []; range?: DateRange | undefined };
};

const WalletHistoryFilter = ({
  onChange,
  filter,
}: WalletHistoryFilterProps) => {
  const { t } = useTranslation();
  const applyRange = (newRange: DateRange) => {
    onChange({ ...filter, range: newRange });
  };

  const resetFilters = () => {
    onChange({ type: [], range: undefined });
  };
  return (
    <HostedPagesFilterPopover.Container>
      <HostedPagesFilterPopover.Trigger
        isFilterEmpty={!filter.range && !filter?.type?.length}
      />
      <HostedPagesFilterPopover.Content>
        <HostedPagesFilterPopover.ContentHeader
          onReset={resetFilters}
          isFilterEmpty={!filter.range && !filter?.type?.length}
        />
        <div className="flex w-full max-w-full flex-col p-4 pt-0">
          <LabeledForm
            label={t("page.userWallets.filter.selectDate")}
            className="mt-4"
          >
            <DatePickerPopover
              label={t("page.userWallets.filter.date")}
              applyRange={applyRange}
              range={filter.range}
            />
          </LabeledForm>
          <LabeledForm
            label={t("page.userWallets.filter.type")}
            className="mt-5 gap-y-2"
          >
            <BadgePicker
              isMulti
              hasAllOption
              options={options}
              onChange={(newValue) => onChange({ ...filter, type: newValue })}
              value={filter.type ?? []}
            />
          </LabeledForm>
        </div>
      </HostedPagesFilterPopover.Content>
    </HostedPagesFilterPopover.Container>
  );
};

export default WalletHistoryFilter;
